/* =============================================
   Logo Slider Section — assets/logo-slider.js
   Desktop: static | Mobile: touch drag scroll
   ============================================= */

(function () {
  'use strict';

  function initLogoSlider(sectionEl) {
    const wrapper = sectionEl.querySelector('.logo-slider__wrapper');
    if (!wrapper) return;

    const bgColor = sectionEl.dataset.bgColor || '#ffffff';
    const logoGap = sectionEl.dataset.logoGap || '48';

    sectionEl.style.setProperty('--logo-slider-bg', bgColor);
    sectionEl.style.setProperty('--logo-gap', logoGap + 'px');

    // Only enable drag scroll on mobile
    function isMobile() {
      return window.innerWidth < 750;
    }

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    // Mouse drag (for desktop testing in small window)
    wrapper.addEventListener('mousedown', function (e) {
      if (!isMobile()) return;
      isDown = true;
      wrapper.classList.add('is-dragging');
      startX = e.pageX - wrapper.offsetLeft;
      scrollLeft = wrapper.scrollLeft;
    });

    wrapper.addEventListener('mouseleave', function () {
      isDown = false;
      wrapper.classList.remove('is-dragging');
    });

    wrapper.addEventListener('mouseup', function () {
      isDown = false;
      wrapper.classList.remove('is-dragging');
    });

    wrapper.addEventListener('mousemove', function (e) {
      if (!isDown || !isMobile()) return;
      e.preventDefault();
      const x = e.pageX - wrapper.offsetLeft;
      const walk = (x - startX) * 1.5;
      wrapper.scrollLeft = scrollLeft - walk;
    });

    // Touch drag — native scroll handles itself via CSS
    // But we add momentum feel via touch events
    wrapper.addEventListener('touchstart', function (e) {
      startX = e.touches[0].pageX;
      scrollLeft = wrapper.scrollLeft;
    }, { passive: true });

    wrapper.addEventListener('touchmove', function (e) {
      if (!isMobile()) return;
      const x = e.touches[0].pageX;
      const walk = startX - x;
      wrapper.scrollLeft = scrollLeft + walk;
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('.logo-slider-section').forEach(function (el) {
      initLogoSlider(el);
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    const sectionEl = e.target.querySelector('.logo-slider-section');
    if (sectionEl) initLogoSlider(sectionEl);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();